import { postForm } from '@/utils/http'

/**
 * 获取预设头像列表
 */
export function getAvatarPresetList() {
  return postForm('/api/index/getAvatarPresetList', {})
}

/**
 * 获取工程师编号
 */
export function getEngineerNo() {
  return postForm('/api/index/getEngineerNo', {})
}

/**
 * 获取首页推荐数据
 */
export function getHomepageRecommend() {
  return postForm('/api/index/getHomepageRecommend', {})
}

/**
 * 获取首页固定数据
 */
export function getHomepageStats() {
  return postForm('/api/index/getHomepageStats', {})
}

/**
 * 获取搜索类型
 */
export function getSearchType() {
  return postForm('/api/index/searchType', {})
}

/**
 * 搜索
 * @param {Object} params
 * @param {string} params.type
 * @param {string|number} params.page
 * @param {string|number} params.limit
 * @param {string} params.keyword
 */
export function searchIndex(params) {
  return postForm('/api/index/search', params)
}

/**
 * 获取公共配置
 */
export function getConfig() {
  return postForm('/api/Index/getConfig', {})
}

/**
 * 获取PC二级页面图片
 */
export function getSecondaryImages() {
  return postForm('/api/Index/getSecondaryImages', {})
}

/**
 * 获取会员规则说明
 */
export function getRule() {
  return postForm('/api/index/getRule', {})
}
